import Vue from "vue";
import VueRouter from "vue-router";
import DebugView from "@/views/debug.vue";
import SettingsView from "../views/settings.vue";
import Welcome from "@/views/welcome.vue";
import Panel from "@/views/panel.vue";
import { supportedViews } from "@/structure";
import settings from "@/synced-settings";

Vue.use(VueRouter);

export const singleView = "single";
export const splitView = "split";
export const sideView = "side";

const routes = [
  {
    name: "debug",
    path: "/debug",
    component: DebugView,
    props: true,
  },
  {
    name: "welcome",
    path: "/welcome",
    component: Welcome,
  },
  {
    path: "/settings/:group",
    component: SettingsView,
    props: true,
  },
  {
    name: singleView,
    path: "/view/:itemID",
    component: Panel,
    props: true,
  },
  {
    name: sideView,
    path: "/view/:itemID/side/:splitID",
    components: {
      default: Panel,
      split: Panel,
    },
    props: {
      default: (route) => ({ itemID: route.params.itemID, position: "main" }),
      split: (route) => ({ itemID: route.params.splitID, position: "side" }),
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_FRONTEND_PREFIX,
  routes,
});

export default router;

function ignoreDuplicatedNavigation(err) {
  // Ignore the vue err regarding  navigating to the page they are already on.
  if (
    err.name !== "NavigationDuplicated" &&
    !err.message.includes("Avoided redundant navigation to current location")
  ) {
    // But print any other errors to the console
    throw err;
  }
}

VueRouter.prototype.safePush = function (path) {
  this.push(path).catch(ignoreDuplicatedNavigation);
};

VueRouter.prototype.safeReplace = function (newPath) {
  this.replace(newPath).catch(ignoreDuplicatedNavigation);
};

VueRouter.prototype.closeSideView = function () {
  this.safePush({
    name: singleView,
    params: { itemID: router.currentRoute.params.itemID },
    query: router.currentRoute.query,
  });
};

VueRouter.prototype.removeFromView = function (itemID) {
  if (this.currentRoute.params.itemID == itemID) {
    // TODO handle situation where previous route had itemID in side view
    this.back();
  }
  if (this.currentRoute.params.splitID == itemID) {
    this.closeSideView();
  }
};

VueRouter.prototype.switchView = function (item) {
  const currentView = this.currentRoute.query?.mainView || "simple";
  const possibleViews = supportedViews(item);
  const curIdx = possibleViews.indexOf(currentView);
  const newIdx = (curIdx + 1) % possibleViews.length;
  const newView = possibleViews[newIdx];
  item.updateLocalData({ preferredView: newView });

  const route = {
    name: this.currentRoute.name,
    params: { itemID: this.currentRoute.params.itemID },
    query: { mainView: newView },
  };
  this.safeReplace(route);
};

VueRouter.prototype.openItem = function (item, event) {
  let curr = this.currentRoute;
  const route = {
    name: singleView,
    params: { itemID: item._id },
  };
  if (
    window.innerWidth < 1360 ||
    (!settings.showSidePanel && item.getCategory() !== "task-like")
  ) {
    const view = item.preferredView || supportedViews(item)[0];
    if (view !== "simple") {
      route.query = { mainView: view };
    }
    this.safePush(route);
    return;
  }
  if (item.getCategory() === "task-like") {
    if (
      (settings.openInSideView && !event.altKey) ||
      (!settings.openInSideView && event.altKey)
    ) {
      route.name = sideView;
      route.params = { itemID: curr.params.itemID, splitID: item._id };
      route.query = curr.query; // TODO fix
    } else if (!settings.showSidePanel) {
      route.name = singleView;
      route.params = { itemID: item._id };
    } else {
      route.name = sideView;
      route.params = { itemID: item._id };
      route.params.splitID = settings.resetSideView
        ? settings.sideView
        : curr.params.splitID || settings.sideView;
    }
  } else {
    const view = item.preferredView || supportedViews(item)[0];
    if (view !== "simple") {
      route.query = { mainView: view };
    }
    if (item.type !== "date") {
      route.name = sideView;
      route.params.splitID = settings.resetSideView
        ? settings.sideView
        : curr.params.splitID || settings.sideView;
    }
  }

  this.safePush(route);
};
